<template>
  <div class="identity-check">
    <IDCardUpload v-if="showIDCardUpload" @nextStep="nextStep" />
    <ExamNotes v-if="showExamNotes" />
    <privacy-modal v-if="showPrivacyModal" @close="showPrivacyModal = false" ></privacy-modal>
  </div>
</template>

<script>
import PrivacyModal from './PrivacyModal'
import IDCardUpload from './IDCardUpload'
import ExamNotes from './ExamNotes'
import { getExamCheckInfo, checkExamIdCard } from '@/apis/exam.api'
export default {
  components: {
    PrivacyModal,
    IDCardUpload,
    ExamNotes
  },
  data() {
    return {
      showPrivacyModal: false,
      curStep: 0,
      showExamNotes: false,
      showIDCardUpload: false,
      openNotice: false
    }
  },
  async mounted () {
    // 为了兼容从其他系统直接跳转过来拿不到 localStorage 的情况
    if (this.$route.query.examId) {
      localStorage.setItem('examId', this.$route.query.examId)
    }
    if (!localStorage.examId) { // 从列表进入
      this.$router.push({ name: 'list' })
    }
    let openNotice = this.$route.params.openNotice
    let openIDVerification = this.$route.params.openIDVerification
    if (openNotice === undefined || openIDVerification === undefined) {
      const config = await getExamCheckInfo(localStorage.examId)
      const noticeConfig = config.exam_config.find((item) => {
        return item.label === 'LARGE_EXAM#exam_notice'
      })
      openNotice = (noticeConfig && noticeConfig.actual_value === '1')
      openIDVerification = +config.identity_verification === 1
    }
    this.openNotice = openNotice

    try {
      // 获取用户是否上传身份证的信息
      const {
        has_face_info
      } = await checkExamIdCard(localStorage.examId)
      const isUploadIdentity = has_face_info

      const needIdentity = openIDVerification && !isUploadIdentity

      if (needIdentity) {
        this.showIDCardUpload = true
        this.showPrivacyModal = true
      } else if (openNotice) {
        this.showExamNotes = true
      } else {
        this.$router.push({ name: 'pretest', query: { examId: localStorage.examId } })
      }
    } catch (e) {
      if (e.error_code === 20607005) {
        this.$router.push({ name: 'list' })
      }
    }
  },
  methods: {
    nextStep() {
      if (this.openNotice) {
        this.showExamNotes = true
        this.showIDCardUpload = false
      } else {
        this.$router.push({ name: 'pretest', query: { examId: localStorage.examId } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .identity-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 50px 0;
    background: #fafafa url("~@/assets/images/detect/bg.png") no-repeat 50% 50% / auto 100%;
    h2 {
      font-weight: 500;
      padding-top: 34px;
    }
  }
  .main-content {
    width: 1200px;
    min-height: 670px;
    overflow: hidden;
    background-color: #fff;
    margin: 0 auto;
    box-shadow: 0 0 20px 0 rgba(57,126,253,0.1);
    border-radius: 8px;
    text-align: center;
  }
</style>
